if (!customElements.get("swym-wishlist-page")) {
	class SwymWishlistPage extends HTMLElement {
		constructor() {
			super();
			this._initializeSwymComponent();
		}

		_init(swat) {
			this._initializeSelectors(swat);
			this.isShareWishlistPage
				? this._renderShareWishlist(swat)
				: this._renderWishlist(swat);
			this._attachEventListeners();
			if (swat.retailerSettings.SFL.SFLFeatureEnabled) {
				this._readySFLContents();
			}
		}

		/* General funcions */

		_initializeSwymComponent() {
			if (!window.SwymCallbacks) window.SwymCallbacks = [];
			window.SwymCallbacks.push(this._init.bind(this));
		}

		_initializeSelectors(swat) {
			this.swat = swat;
			this.body = document.body;
			this.settings = JSON.parse(this.dataset.settings);
			this.isShareWishlistPage = window.isShareListPage;
			this.multipleWishlistsEnabled =
				swat.retailerSettings.Wishlist.EnableCollections;

			/* Page Header Selectors */
			this.accountButton = this.querySelector("#swymcs-user-login-status-btn");
			this.accountButtonText = this.accountButton.querySelector(
				".swymcs-user-text.swym-value"
			);
			this.accountPopup = this.querySelector("#swymcs-user-login-status-popup");
			this.accountPopupTitleText = this.accountPopup.querySelector(
				"#swymcs-account-popup-title"
			);
			this.accountPopupContentText = this.accountPopup.querySelector(
				"#swymcs-account-info"
			);
			this.accountPopupCloseButton = this.querySelector(
				"#swymcs-close-account-popup"
			);
			this.accountPopupCancelButton = this.querySelector(
				"#swymcs-cancel-account-popup"
			);
			this.accountPopupActionButton = this.querySelector(
				"#swymcs-account-login-action-button"
			);

			this.shareListAccountPopup = this.querySelector(
				"#swymcs-share-list-login-status-popup"
			);
			this.shareListAccountPopupTitleText = this.querySelector(
				"#swymcs-share-list-account-popup-title"
			);
			this.shareListAccountPopupContentText1 = this.querySelector(
				"#swymcs-share-list-account-info-1"
			);
			this.shareListAccountPopupContentText2 = this.querySelector(
				"#swymcs-share-list-account-info-2"
			);
			this.shareListAccountPopupCloseButton = this.querySelector(
				"#swymcs-close-share-list-account-popup"
			);
			this.shareListAccountPopupCancelButton = this.querySelector(
				"#swymcs-cancel-share-list-account-popup"
			);
			this.shareListAccountPopupActionButton = this.querySelector(
				"#swymcs-share-list-account-login-action-button"
			);

			/* Wishlist grid container */
			this.titleTabWrapper = this.querySelector("#swym-cs-title-wrapper");
			this.singleWishlistTitleText = this.querySelector("#swymcs-page-title");
			this.sflTitleText = this.querySelector("#swymcs-sfl-page-title");
			this.emptyListContainer = this.querySelector(
				"#swym-empty-wishlist-container"
			);
			this.emptySFLListContainer = this.querySelector(
				"#swym-empty-sfl-container"
			);
			this.wishlistContainer = this.querySelector("#swymcs-wishlist-container");
			this.listsContainer = this.querySelector("#swymcs-lists-grid");
			this.listProductsContainer = this.querySelector(
				"#swymcs-products-grid-container"
			);
			this.productsContainer = this.querySelector("#swymcs-products-grid");
			this.sflProductsContainer = this.querySelector(
				"#swymcs-sfl-products-grid"
			);
			this.wishlistHeader = this.querySelector("#swymcs-wishlist-header");
			this.backToListView = this.querySelector("#swymcs-back-to-lists-view");
			this.backToListButtonText = this.querySelector("#swymcs-back-to-lists-view span")

			/* Lists header selectors */
			this.activeListContainer = this.querySelector("#swymcs-active-list");
			this.activeListImage = this.querySelector("#swymcs-active-list-image");
			this.activeListImageText = this.querySelector(
				"#swymcs-active-list-image-text"
			);
			this.activeListTilte = this.querySelector("#swymcs-active-list-title");
			this.activeListItemCount = this.querySelector(
				"#swymcs-active-list-item-count"
			);
			this.headerListsContainer = this.querySelector("#swymcs-header-lists");

			/* Additional Options selectors */

			this.additionalOptionsContainer = this.querySelector(
				"#swymcs-additional-options"
			);
			this.additionalOptionsBtn = this.querySelector(
				"#swymcs-view-additional-options"
			);
			this.shareListButton = this.querySelector("#swymcs-share-list");
			this.renameListButton = this.querySelector("#swymcs-rename-list");
			this.duplicateListButton = this.querySelector("#swymcs-duplicate-list");
			this.deleteListButton = this.querySelector("#swymcs-delete-list");
			this.renameListButtonText = this.renameListButton.querySelector(
				".swymcs-share-button-text"
			);
			this.duplicateListButtonText = this.duplicateListButton.querySelector(
				".swymcs-share-button-text"
			);
			this.deleteListButtonText = this.deleteListButton.querySelector(
				".swymcs-share-button-text"
			);

			/* Additional Options popup selectors */
			this.additionalOptionsPopupContainer = this.querySelector(
				"#swymcs-additional-options-popup-container"
			);
			this.additionalOptionsPopupCloseButton = this.querySelector(
				"#swymcs-close-additional-popup"
			);
			this.additionalPopupCancelButtons = this.querySelectorAll(
				".swymcs-additonal-popup-cancel-button"
			);

			/* Share List popup selectors */
			this.shareListPopup = this.querySelector("#swymcs-share-list-popup");
			this.shareLinkField = this.querySelector("#swymcs-share-link-field");
			this.shareNameField = this.querySelector("#swymcs-share-name-field");
			this.shareEmailField = this.querySelector("#swymcs-share-email-field");
			this.shareMessageField = this.querySelector(
				"#swymcs-share-message-field"
			);
			this.shareListError = this.querySelector(
				"#swymcs-share-email-field-error"
			);
			this.emailShareButton = this.querySelector("#swymcs-confirm-share-list");
			this.copyLinkButton = this.querySelector(
				"#swymcs-confirm-share-list--copy"
			);
			this.shareListPopupTitle = this.shareListPopup.querySelector(
				".swymcs-confirm-share-title"
			);
			this.shareListPopupSenderNameLabel = this.shareListPopup.querySelector(
				'[for="swymcs-share-name-field"]'
			);
			this.shareListPopupSenderEmailLabel = this.shareListPopup.querySelector(
				'[for="swymcs-share-email-field"]'
			);
			this.shareListPopupSenderNotesLabel = this.shareListPopup.querySelector(
				'[for="swymcs-share-message-field"]'
			);
			this.shareWishlistAlternateShareLabel = this.shareListPopup.querySelector(
				".swymcs-confirm-share-subtitle"
			);
			this.shareWishlistClosePopup = this.shareListPopup.querySelector(
				"#swymcs-cancel-share-list"
			);
			this.copyLinkLabel = this.shareListPopup.querySelector(
				"#swymcs-confirm-share-list--copy .swymcs-share-button-text"
			);
			this.facebookShareButton = this.querySelector(
				"#swymcs-confirm-share-list--facebook"
			);
			this.twitterShareButton = this.querySelector(
				"#swymcs-confirm-share-list--twitter"
			);

			/* Delete List popup selectors */
			this.deleteListPopup = this.querySelector("#swymcs-delete-list-popup");
			this.deleteListName = this.querySelector(
				"#swymcs-confirm-delete-list-name"
			);
			this.deleteListPopupTitleText = this.deleteListPopup.querySelector(
				".swymcs-confirm-delete-title"
			);
			this.confirmDeleteListButton = this.querySelector(
				"#swymcs-confirm-delete-list"
			);
			this.deleteListPopupCancelBtn = this.querySelector(
				"#swymcs-cancel-delete-list"
			);

			/* Rename List popup selectors */
			this.renameListPopup = this.querySelector("#swymcs-rename-list-popup");
			this.renameListPopupTitleText = this.querySelector(
				".swymcs-confirm-rename-title"
			);
			this.renameListPopupText = this.renameListPopup.querySelector(".swymcs-popup-text");
			this.renameListName = this.querySelector(
				"#swymcs-confirm-rename-list-name"
			);
			this.renameListError = this.querySelector("#swymcs-rename-list-error");
			this.renameListTextField = this.querySelector(
				"#swymcs-rename-list-field"
			);
			this.confirmRenameListButton = this.querySelector(
				"#swymcs-confirm-rename-list"
			);
			this.cancelRenameListButton = this.querySelector(
				"#swymcs-cancel-rename-list"
			);

			/* Duplicate List popup selectors */
			this.duplicateListPopup = this.querySelector(
				"#swymcs-duplicate-list-popup"
			);
			this.duplicateListPopupTitleText = this.querySelector(
				".swymcs-confirm-duplicate-title"
			);
			this.duplicateListPopupText = this.duplicateListPopup.querySelector(".swymcs-popup-text");
			this.duplicateListName = this.querySelector(
				"#swymcs-confirm-duplicate-list-name"
			);
			this.duplicateListError = this.querySelector(
				"#swymcs-duplicate-list-error"
			);
			this.duplicateListTextField = this.querySelector(
				"#swymcs-duplicate-list-field"
			);
			this.confirmDuplicateListButton = this.querySelector(
				"#swymcs-confirm-duplicate-list"
			);
			this.cancelDuplicateListButton = this.querySelector(
				"#swymcs-cancel-duplicate-list"
			);

			/* Wishlist Footer selectors */
			this.wishlistFooter = this.querySelector("#swymcs-total-container");
			this.subTotalField = this.querySelector("#swymcs-wishlist-total");
			this.addAddToCartButton = this.querySelector(
				"#swymcs-add-all-to-cart-btn"
			);

			this.pageLoader = this.querySelector("#swymcs-loader-container");
			this.wishlistSectionContainer = this.querySelector(
				".swymcs-wishlist-section-container"
			);
			/* Wishlist Selectors for Strings */
			this.emptyListTitle = this.emptyListContainer.querySelector(
				"#swym-empty-wishlist-container-title"
			);
			this.emptyListDescription = this.emptyListContainer.querySelector(
				"#swym-empty-wishlist-container-description"
			);
			this.emptyListButton = this.emptyListContainer.querySelector(
				"#swym-custom-continue-shopping"
			);
			this.emptySFLListTitle = this.emptySFLListContainer.querySelector(
				"#swym-empty-sfl-container-title"
			);
			this.emptySFLListButton = this.emptySFLListContainer.querySelector(
				"#swym-custom-continue-shopping"
			);

			if (!window.isCustomer) {
				this.guestMessageButton = this.querySelector("#swymcs-guest-user-btn");
			}

			this.addToCartAddedText =
				this.dataset.addedToCartText ||
				swat.retailerSettings.Strings.AddToCartCTAAlreadyAdded ||
				this.settings.added_to_cart_text;
			this.addToCartCanAddText =
				this.dataset.addToCartText ||
				swat.retailerSettings.Strings.AddToCartCTACanAdd ||
				this.settings.add_to_cart_text;
			this.addToCartSoldOutText =
				this.dataset.soldOutText ||
				swat.retailerSettings.Strings.AddToCartCTACannotAdd ||
				this.settings.sold_out_text;
		}

		_attachEventListeners() {
			this.body.addEventListener("click", (evt) => this._overlayEvent(evt));
			this.addEventListener(
				"swym:product-grid-loaded",
				this._updateLocaleStrings.bind(this)
			);

			// Adding events for switching between WL view and SFL view
			this.titleTabWrapper.addEventListener("click", (e) => {
				this._switchUIView(e.target.dataset.type);
			});
			// this.singleWishlistTitleText.addEventListener("click", (e) => {
			//   this._switchUIView(e.currentTarget.dataset.type);
			// });
			// this.sflTitleText.addEventListener("click", (e) => {
			//   this._switchUIView(e.currentTarget.dataset.type);
			// });

			/* Adding events to page header elements */

			this.accountButton.addEventListener("click", (evt) =>
				this._showPopupContainer(this.accountPopup)
			);
			this.accountPopupCloseButton.addEventListener("click", (evt) =>
				this._hidePopupContainer(this.accountPopup)
			);
			this.accountPopupCancelButton.addEventListener("click", (evt) =>
				this._hidePopupContainer(this.accountPopup)
			);
			this.accountPopupActionButton.addEventListener(
				"click",
				this._loginButtonAction.bind(this)
			);

			this.shareListAccountPopupActionButton.addEventListener(
				"click",
				this._loginButtonAction.bind(this)
			);
			this.shareListAccountPopupCloseButton.addEventListener("click", (evt) =>
				this._hidePopupContainer(this.shareListAccountPopup)
			);
			this.shareListAccountPopupCancelButton.addEventListener("click", (evt) =>
				this._hidePopupContainer(this.shareListAccountPopup)
			);

			/* Header Lists Events */

			this.activeListContainer.addEventListener("click", (evt) =>
				this._showPopupContainer(this.headerListsContainer)
			);
			this.headerListsContainer.addEventListener(
				"click",
				this._switchListsFromHeader
			);

			/* Additional Options Events */
			this.additionalOptionsBtn.addEventListener("click", (evt) =>
				this._showPopupContainer(this.additionalOptionsContainer)
			);
			this.additionalOptionsContainer.addEventListener(
				"click",
				this._renderAdditionalOptionsPopup
			);
			this.shareListButton.addEventListener(
				"click",
				this._renderShareListPopup.bind(this)
			);

			/* Additional Options Popup Events */
			this.additionalPopupCancelButtons.forEach((btn) =>
				btn.addEventListener(
					"click",
					this._closeAdditionalOptionsPopup.bind(this)
				)
			);
			this.additionalOptionsPopupCloseButton.addEventListener(
				"click",
				this._closeAdditionalOptionsPopup.bind(this)
			);

			/* Share List Events */
			this.copyLinkButton.addEventListener(
				"click",
				this._shareListByCopy.bind(this)
			);
			this.emailShareButton.addEventListener(
				"click",
				this._shareListByEmail.bind(this)
			);
			this.facebookShareButton.addEventListener("click", (evt) =>
				this._shareListOnPlatform("facebook")
			);
			this.twitterShareButton.addEventListener("click", (evt) =>
				this._shareListOnPlatform("twitter")
			);
			this.shareEmailField.addEventListener(
				"input",
				this._validateEmail.bind(this)
			);

			/* Rename List Events */
			this.confirmRenameListButton.addEventListener(
				"click",
				this._renameList.bind(this)
			);
			this.renameListTextField.addEventListener("input", (evt) =>
				this._validateListName(
					this.renameListTextField.value.trim().toLowerCase(),
					this.renameListError
				)
			);

			/* Duplicate List Events */
			this.confirmDuplicateListButton.addEventListener(
				"click",
				this._duplicateList.bind(this)
			);
			this.duplicateListTextField.addEventListener("input", (evt) =>
				this._validateListName(
					this.duplicateListTextField.value.trim().toLowerCase(),
					this.duplicateListError
				)
			);

			/* Delete List Events */
			this.confirmDeleteListButton.addEventListener(
				"click",
				this._deleteList.bind(this)
			);

			/* Lists grid buttons */
			this.listsContainer.addEventListener(
				"click",
				this._showListDetails.bind(this)
			);
			this.productsContainer.addEventListener(
				"click",
				this._eventsForProductsGrid
			);
			this.sflProductsContainer.addEventListener(
				"click",
				this._eventsForProductsGrid
			);
			this.backToListView.addEventListener(
				"click",
				this._triggerBackToListView.bind(this)
			);

			/* Wishlist Footer buttons */
			this.addAddToCartButton.addEventListener(
				"click",
				this._addAllProductToCart.bind(this)
			);

			// // Update SFL contianer if product added to sfl dynamically
			// this.swat.evtLayer.addEventListener(this.swat.JSEvents.addedToSFL, () => {
			//   this._renderSFLContainer();
			// });
		}

		_initSFL() {
			return new Promise(async (resolve, reject) => {
				this.swat.SaveForLater.init(
					(listContents) => resolve(listContents),
					(error) => reject(error)
				);
			});
		}
		_updateLocaleStrings() {
			const swat = this.swat;
			// const currentLocale = Shopify.locale;
			const loggedInAccountPopupText =
				swat.retailerSettings.Strings.SaveListPopupLoggedInText + '\n' + window.customerEmail;
			const shareListNotesLabel =
				swat.retailerSettings.Strings.ShareWishlistPopupNoteDefault.replace(
					/{{{?wishlistName}?}}/g,
					swat.retailerSettings.Strings.SingleWishlistTitle
				);
			this.ShareWishlistEmailSuccess =
				swat.retailerSettings.Strings.ShareWishlistEmailSuccess.replace(
					/{{{?wishlistName}?}}/g,
					swat.retailerSettings.Strings.SingleWishlistTitle
				);
			this.ShareWishlistCopylinkSuccess =
				swat.retailerSettings.Strings.ShareWishlistCopylinkSuccess.replace(
					/{{{?wishlistName}?}}/g,
					swat.retailerSettings.Strings.SingleWishlistTitle
				)

			/* MENU CONTAINER BUTTONS */
			this.accountButtonText.textContent = window.isCustomer
				? window.customerEmail
				: swat.retailerSettings.Strings.GuestShopperTitle;

			// RENAME LIST POPUP
			this.renameListButtonText.textContent =
				swat.retailerSettings.Strings.RenameWishlistModalHeading;
			this.renameListPopupTitleText.textContent = swat.retailerSettings.Strings.RenameWishlistModalHeading;
			this.renameListPopupText.textContent = swat.retailerSettings.Strings.RenameWishlistModalInputPlaceholder;
			this.cancelRenameListButton.textContent = swat.retailerSettings.Strings.DuplicateWishlistPopupCTACancel;
			this.confirmRenameListButton.textContent = swat.retailerSettings.Strings.AcceptMarketingPopUpSubscribeCTA;

			// DUPLICATE LIST POPUP
			this.duplicateListButtonText.textContent =
				swat.retailerSettings.Strings.DuplicateWishlistPopupHeading;
			this.duplicateListPopupTitleText.textContent = swat.retailerSettings.Strings.DuplicateWishlistPopupHeading;
			this.duplicateListPopupText.textContent = swat.retailerSettings.Strings.RenameWishlistModalInputPlaceholder;
			this.cancelDuplicateListButton.textContent = swat.retailerSettings.Strings.DuplicateWishlistPopupCTACancel;
			this.confirmDuplicateListButton.textContent = swat.retailerSettings.Strings.DuplicateWishlistPopupCTADuplicate;


			this.deleteListButtonText.textContent =
				swat.retailerSettings.Strings.WishlistContextMenuClearList;
			this.backToListButtonText.textContent =
				swat.retailerSettings.Strings.BackToListofListsCTA;
			this.accountPopupTitleText.textContent =
				swat.retailerSettings.Strings.SaveListPopupSummaryHeading;
			this.singleWishlistTitleText.textContent =
				swat.retailerSettings.Strings.WishlistMainTitle ??
				this.settings.page_title;
			this.sflTitleText.textContent = this.settings.sfl_page_title;

			/* NOT LOGGED IN CUSTOMER - ACCOUNT POPUP CONTAINER */
			this.accountPopupActionButton.textContent = window.isCustomer
				? swat.retailerSettings.Strings.SaveListPopupLoggedInCTASave
				: swat.retailerSettings.Strings.SaveListPopupSummaryCTALogin;
			this.accountPopupContentText.innerHTML = window.isCustomer
				? loggedInAccountPopupText
				: swat.retailerSettings.Strings.SaveListPopupSummaryText;
			this.accountPopupCancelButton.textContent =
				swat.retailerSettings.Strings.SaveListPopupLoggedInCTACancel;

			/* DELETE LIST POPUP CONTAINER */
			this.deleteListPopupTitleText.textContent =
				swat.retailerSettings.Strings.ClearWishlistPopupHeading;
			this.confirmDeleteListButton.textContent =
				swat.retailerSettings.Strings.ClearWishlistPopupCTAClear;
			this.deleteListPopupCancelBtn.textContent =
				swat.retailerSettings.Strings.ClearWishlistPopupCTACancel;

			/* NOT LOGGED IN CUSTOMER - SHARE LIST POPUP CONTAINER */
			this.shareListAccountPopupTitleText.textContent =
				swat.retailerSettings.Strings.ShareWishlistLoginPopupHeading;
			this.shareListAccountPopupActionButton.textContent =
				swat.retailerSettings.Strings.SharedWishlistLoginCTA;
			this.shareListAccountPopupContentText1.textContent =
				swat.retailerSettings.Strings.ShareWishlistLoginPopupText;
			this.shareListAccountPopupContentText2.textContent =
				swat.retailerSettings.Strings.ShareWishlistLoginPopupMessage;

			/* SHARE LIST POPUP CONTAINER */
			this.shareListPopupTitle.textContent =
				swat.retailerSettings.Strings.ShareWishlistPopupHeading;
			this.shareListPopupSenderNameLabel.textContent =
				swat.retailerSettings.Strings.ShareWishlistSenderName;
			this.shareNameField.placeholder =
				swat.retailerSettings.Strings.ShareWishlistNamePlaceholder;
			this.shareListPopupSenderEmailLabel.textContent =
				swat.retailerSettings.Strings.ShareWishlistRecipientsEmail;
			this.shareEmailField.placeholder =
				swat.retailerSettings.Strings.ShareWishlistEmailPlaceholder;
			this.shareListPopupSenderNotesLabel.textContent =
				swat.retailerSettings.Strings.ShareWishlistMessage;
			this.shareMessageField.placeholder =
				swat.retailerSettings.Strings.ShareWishlistNotePlaceholder;
			this.shareMessageField.value = shareListNotesLabel;
			this.emailShareButton.textContent =
				swat.retailerSettings.Strings.ShareWishlistEmailCTA;
			this.shareWishlistAlternateShareLabel.textContent =
				swat.retailerSettings.Strings.ShareWishlistAlternateShareLabel;
			this.shareWishlistClosePopup.textContent =
				swat.retailerSettings.Strings.SaveListPopupLoggedInCTACancel;
			this.copyLinkLabel.textContent =
				swat.retailerSettings.Strings.ShareWishlistCopyLinkText;

			/* EMPTY LIST CONTAINER */
			this.emptyListTitle.textContent =
				swat.retailerSettings.Strings.EmptyWishlistsHeading;
			this.emptyListDescription.textContent =
				swat.retailerSettings.Strings.EmptyWishlistsText;
			this.emptyListButton.textContent =
				swat.retailerSettings.Strings.EmptyWishlistsCTA;
			this.emptySFLListTitle.textContent =
				swat.retailerSettings.Strings.SFLListEmptyText;
			this.emptySFLListButton.textContent =
				swat.retailerSettings.Strings.SFLOpenCartCTA;

			window.emptyListContent = this.emptyListContainer.outerHTML;
			window.emptySFLListContent = this.emptySFLListContainer.outerHTML;

			this._hideContainer(this.pageLoader);
			this._showContainer(this.wishlistSectionContainer);
		}

		async _triggerBackToListView() {
			this._renderWishlist(_swat);
		}

		_showListDetails(evt) {
			const target = evt.target;
			// const page = document.querySelector("swym-wishlist-page");
			if (target.getAttribute("id") != "swymcs-lists-grid") {
				const lid = evt.target.closest(".swymcs-list-item").dataset.lid;
				const action = target?.dataset?.action || "view-list";
				if (
					target.classList.contains("swymcs-view-list-button") &&
					action == "shop"
				)
					location.href = "/";
				else this._renderListProducts(lid);
			}
			return;
		}

		async _renderWishlist() {
			this.lists = await this._getLists();
			this.lists.length
				? this.multipleWishlistsEnabled
					? this._renderWishlists()
					: this._renderSingleWishlist()
				: this._renderEmptyState();
		}

		async _renderShareWishlist() {
			const params = new URL(document.location).searchParams;
			const lid = params.get("lid");
			if (!lid) {
				console.log("Could not find lid");
				this._renderProductsGrid([]);
				this._hideContainer(this.wishlistHeader);
				this._hideContainer(this.backToListView);
				this._showContainer(this.wishlistContainer);
				this._showContainer(this.listProductsContainer);
				return;
			}
			// console.log("Share Wishlist Rendering");
			const wishlistProducts = await this._getProductsFromList(lid);
			const shopifyProductsData = await this._getShopifyProductsData(
				wishlistProducts
			);
			const activeList = await this._getListDetails(lid);
			// await this._renderSharedListHeader(lid);
			if (activeList.list.lty == "wl") {
				this._renderProductsGrid(shopifyProductsData, "wl");
				this._showContainer(this.wishlistContainer);
				this._showContainer(this.listProductsContainer);
			} else if (activeList.list.lty == "sfl") {
				this._renderProductsGrid(shopifyProductsData, "sfl");
				this._showContainer(this.wishlistContainer);
				this._showContainer(this.sflProductsContainer);
			}
			this._hideContainer(this.backToListView);
			this._hideContainer(this.wishlistHeader);
			this._hideContainer(this.titleTabWrapper);
		}

		async _readySFLContents() {
			this._initSFL()
				.then(async (success) => {
					window.saveForLaterListId = success.listid;
					await this._renderSFLContainer();
				})
				.catch((error) => {
					console.log("Error in Initializing SFL", error);
				});
		}

		_getProductsFromSflList(saveForLaterListId) {
			return new Promise(async (resolve, reject) => {
				this.swat.SaveForLater.fetch(
					saveForLaterListId,
					(sflFetchResponse) => resolve(sflFetchResponse),
					(error) => reject(error)
				);
			});
		}

		async _renderSFLContainer() {
			this._showContainer(this.sflTitleText);
			const sflFetchResponse = await this._getProductsFromSflList(
				window.saveForLaterListId
			);
			const sflProducts = sflFetchResponse.items;
			window.sflProductsCount = sflProducts.length;
			const shopifyProductsData = await this._getShopifyProductsData(
				sflProducts
			);
			// await this._renderSingleListHeader(window.saveForLaterListId);
			// this._hideContainer(this.productsContainer);
			this._renderProductsGrid(shopifyProductsData, "sfl");
		}

		_showSflProductsContainer() {
			this._hideContainer(this.emptyListContainer);
			this._hideContainer(this.emptySFLListContainer);
			this._renderSingleListHeader("sfl");
			this._hideContainer(this.productsContainer);
			this._showContainer(this.wishlistContainer);
			this._showContainer(this.sflProductsContainer);
		}

		_showWlProductsContainer() {
			this._hideContainer(this.emptyListContainer);
			this._hideContainer(this.emptySFLListContainer);
			this._renderSingleListHeader("wl");
			this._hideContainer(this.sflProductsContainer);
			this._showContainer(this.wishlistContainer);
			this._showContainer(this.productsContainer);
		}

		_switchUIView(type) {
			if (
				type === "wl" &&
				!this.singleWishlistTitleText.classList.contains("swymcs-active-tab")
			) {
				if (window.wishlistProductCount > 0) this._showWlProductsContainer();
				else this._renderEmptyState();
				this.singleWishlistTitleText.classList.toggle("swymcs-active-tab");
				this.sflTitleText.classList.toggle("swymcs-active-tab");
			} else if (
				type === "sfl" &&
				!this.sflTitleText.classList.contains("swymcs-active-tab")
			) {
				if (window.sflProductsCount > 0) this._showSflProductsContainer();
				else this._renderEmptySFLState();
				this.sflTitleText.classList.toggle("swymcs-active-tab");
				this.singleWishlistTitleText.classList.toggle("swymcs-active-tab");
			} else return;
		}
		async _renderSingleWishlist() {
			window.currentActiveListId = this.lists[0].lid;
			const wishlistProducts = await this._getProductsFromList(
				window.currentActiveListId
			);
			window.wishlistProductCount = wishlistProducts.length;
			if (!wishlistProducts.length) {
				this._renderEmptyState();
				return;
			}
			const shopifyProductsData = await this._getShopifyProductsData(
				wishlistProducts
			);
			await this._renderSingleListHeader("wl");
			this._renderProductsGrid(shopifyProductsData, "wl");
			this._showContainer(this.wishlistContainer);
			this._showContainer(this.listProductsContainer);
			// this._showContainer(this.additionalOptionsMenuContainer);
		}

		async _renderSingleListHeader(type) {
			this._showContainer(this.shareListButton);
			this._hideContainer(this.activeListContainer);
			this._hideContainer(this.backToListView);
			this._hideContainer(this.duplicateListButton);
			this._hideContainer(this.renameListButton);
			if (type == "wl") {
				this.shareListButton.dataset.lid = window.currentActiveListId;
				this.emailShareButton.dataset.lid = window.currentActiveListId;
				this._showContainer(this.additionalOptionsBtn);
			}
			if (type == "sfl") {
				this.shareListButton.dataset.lid = window.saveForLaterListId;
				this.emailShareButton.dataset.lid = window.saveForLaterListId;
				this._hideContainer(this.additionalOptionsBtn);
			}
			// this._hideContainer(this.wishlistFooter);
		}

		_renderWishlists() {
			this._renderListsView();
			this.emptyListContainer.classList.add("swym-hide-container");
			this.wishlistContainer.classList.remove("swym-hide-container");
		}

		_renderEmptyState() {
			// this._hideContainer(this.additionalOptionsMenuContainer);
			this._showContainer(this.emptyListContainer);
			this._hideContainer(this.emptySFLListContainer);
			this._hideContainer(this.wishlistContainer);
			this.dispatchEvent(new CustomEvent("swym:product-grid-loaded"));
		}

		_renderEmptySFLState() {
			this._showContainer(this.emptySFLListContainer);
			this._hideContainer(this.emptyListContainer);
			this._hideContainer(this.wishlistContainer);
			this.dispatchEvent(new CustomEvent("swym:product-grid-loaded"));
		}
		async _renderListsView() {
			window.currentActiveListId = "";
			let html = ``;
			this.lists.forEach((list) => {
				const listContents = list?.listcontents || [];

				let buttonText = !listContents.length
					? `${this.settings.empty_wishlist_cta}`
					: `${this.swat.retailerSettings.Strings.ViewListCTA ?? this.settings.view_list_cta}`;
				let buttonAction = !listContents.length ? "shop" : "view-list";
				let imageHtml = `<div class="swymcs-list-image-container">`;
				if (listContents.length) {
					for (let i = 0; i < 3; i++) {
						if (listContents[i]) {
							imageHtml += `
                                <div class="swymcs-wishlist-image-wrapper">
                                    <img src="${listContents[i].iu}" alt="${listContents[i].dt}" class="swymcs-wishlist-image"/>
                                </div>`;
						}
					}
					imageHtml += "</div>";
				} else
					imageHtml += ` <p class="swymcs-no-products-message">${this.settings.empty_list_card_text}</p></div>`;

				html += `
                    <button class="swymcs-button swymcs-list-item swymcs-wishlist-grid-item" data-lid="${
					list.lid
				}" aria-label="View list ${list.lname}" id="list--${
					list.lid
				}">
                        <div class="swymcs-list-title-container">
                            <div class="swymcs-list-title">${list.lname}</div>
                        </div>
                        <div class="swymcs-list-product-count-container">
                            <span class="swymcs-product-count">${
					listContents.length
				}</span>
                            <span class="swymcs-product-count-text">${
					listContents.length == 1
						? this.dataset.productCountSingular || this.settings.product_count_singular
						: this.dataset.productCountPlural || this.settings.product_count_plural
				}</span>
                        </div>
                        ${imageHtml}
                        <div class="swymcs-view-list-button swymcs-major-button" data-action="${buttonAction}" id="swymcs-view-list-button-${
					list.lid
				}" aria-label="${buttonText}">
                            ${buttonText}
                        </div>
                    </button>
                `;
			});
			this.dispatchEvent(new CustomEvent("swym:product-grid-loaded"));
			this.listsContainer.innerHTML = html;
			this._showContainer(this.listsContainer);
			this._hideContainer(this.listProductsContainer);
			this._hideContainer(this.pageLoader);
			this._scrollToTop();
		}

		async _renderListProducts(lid) {
			this._hideContainer(this.listsContainer);
			this._hideContainer(this.listProductsContainer);
			this._showContainer(this.pageLoader);
			window.currentActiveListId = lid;
			const wishlistProducts = await this._getProductsFromList(lid);
			window.wishlistProductCount = wishlistProducts.length;
			if (wishlistProducts.length == 0) {
				this._renderEmptyList();
			} else {
				const shopifyProductsData = await this._getShopifyProductsData(
					wishlistProducts
				);
				this._renderProductsGrid(shopifyProductsData, "wl");
			}
			this._renderListHeader(lid);
			this._showContainer(this.listProductsContainer);
			this._hideContainer(this.pageLoader);
		}

		async _renderSharedListHeader(lid) {
			const activeList = await this._getListDetails(lid);
			activeList.list.lty == "wl";
			// this._renderActiveList(activeList.list);
			// this.activeListContainer.style.pointerEvents = "none";
			this._hideContainer(this.additionalOptionsBtn);
			this._hideContainer(this.shareListButton);
		}

		_renderListHeader(lid) {
			const lists = this.lists;
			const activeList = lists.find((list) => list.lid == lid);
			this._renderActiveList(activeList);

			// Update share button data-lid for multiple wishlist scenario
			this.shareListButton.dataset.lid = lid;
			this.emailShareButton.dataset.lid = lid;

			let html = ``;
			lists.forEach((list, index) => {
				const listContents = list?.listcontents || [];
				if (listContents.length) {
					html += `
                    <li class="swymcs-header-list-item" data-lid="${list.lid}">
                        <img src="${listContents[0].iu}" alt="listContents[0].dt"/>
                        <span class="swym-list-item">${list.lname} (${listContents.length})</span>
                    </li>`;
				} else {
					html += `
                    <li class="swymcs-header-list-item" data-lid="${list.lid}">
                        <span class="swymcs-list-item-image-text">${list.lname[0]}</span>
                        <span class="swymcs-list-item">${list.lname} (0)</span>
                    </li>`;
				}
			});
			this.headerListsContainer.innerHTML = html;
		}

		_renderActiveList(list) {
			const listContent = list?.listcontents || [];
			this.activeListTilte.textContent = list.lname;
			this.activeListItemCount.textContent = `(${listContent.length})`;
			if (listContent.length) {
				this.activeListImage.src = listContent[0].iu;
				this.activeListImage.alt = listContent[0].lname;
				this._hideContainer(this.activeListImageText);
				this._showContainer(this.activeListImage);
			} else {
				this.activeListImageText.textContent = list.lname[0];
				this.activeListImage.alt = listContent.lname;
				this._hideContainer(this.activeListImage);
				this._showContainer(this.activeListImageText);
			}
		}

		_renderProductsGrid(shopifyProducts, type = null) {
			if (!shopifyProducts.length) {
				if (type == "wl") {
					this._renderEmptyList();
				} else if (type == "sfl") {
					this._renderEmptySFLState();
				}
				return;
			}
			let productMarkup = ``;
			shopifyProducts.forEach(async (pdp, index) => {
				if (!pdp) return;
				const product = pdp.productData;
				const selectedVariant = product.variants.find(
					(variant) => variant.id === pdp.epi
				);
				// console.log("Selected variant", selectedVariant);
				// const selectedVariantTitle =
				//   selectedVariant.title &&
				//   selectedVariant.title.toLowerCase() != "default title"
				//     ? selectedVariant.title
				//     : "";

				const formatPrice = (price) => {
					return new Intl.NumberFormat("de-DE", {
						minimumFractionDigits: 2,
						maximumFractionDigits: 2,
					}).format(price / 100);
				};
				// const selectedVariantPrice = parseFloat(selectedVariant.price / 100.0)
				//   .toFixed(2)
				//   .replace(".", ",");
				const selectedVariantPrice = formatPrice(selectedVariant.price);
				let addToCartBtnText = selectedVariant.available
					? _swat.platform.isInDeviceCart(selectedVariant.id)
						? this.addToCartAddedText
						: this.addToCartCanAddText
					: this.addToCartSoldOutText;
				const inCart = _swat.platform.isInDeviceCart(selectedVariant.id)
					? "swymcs-product-in-cart"
					: "";
				const lid = pdp.lid;
				let isSoldOut = !selectedVariant.available ? "swymcs-sold-out" : "";
				let isButtonDisabled = isSoldOut ? "disabled" : "";
				const imageSrc =
					selectedVariant?.featured_image?.src ||
					product?.featured_image ||
					pdp.iu;
				const productUrl = product?.productUrl || pdp.du;

				productMarkup += `
        <li class="grid__item swymcs-product-card">
       <div class="card-wrapper product-miniature product-card-wrapper">
    <div class="card card--standard card--media color-background-1 gradient" style="--ratio-percent: 100.0%;">
       <div class="card__inner ratio" style="--ratio-percent: 100.0%;">
          <div class="card__media ">
             <div class="media media--transparent media--hover-effect">
                <img sizes="(min-width: 1600px) 350px, (min-width: 990px) calc((100vw - 180px) / 4), (min-width: 750px) calc((100vw - 100px) / 3), calc((100vw - 50px) / 2)" alt="${
					product.title
				}" class="motion-reduce" loading="lazy" width="200" height="200"
                   src="${imageSrc}">
             </div>
          </div>
       </div>
      <div class=" card__content">
        <div class="card__information">
            <div class="card__heading-container">
                <div class="card__subheading">${product.type}</div>
                    <span class="card__heading h5">
                    <a href="${productUrl}" class="full-unstyled-link" style="min-height: 3.3rem" data-position="29">${
					product.title + ' - ' + selectedVariant.title
				}</a>
                    </span>
                </div>
            <div class="card__information-container">
                <div class="card-information">
                    <span class="caption-large light"></span>
                    <div class="price ">
                        <div class="price__container">
                            <span class="price-item price-item--regular">
                            <span class="finalPrice">${selectedVariantPrice}${currencyCode}</span>
                            </span>
                        </div>
                    </div>
                            <button data-lid="${lid}" data-purpose="delete" data-epi="${
					selectedVariant.id
				}" data-empi="${product.id}" data-du="${
					pdp.du
				}" data-type="${type}" class="${
					this.isShareWishlistPage && "swym-hide-container"
				} swymcs-has-after-css swymcs-button swymcs-product-delete-btn swym-nav swym-nav-1 swym-is-button" aria-label="${
					this.settings.swym_delete_list_text
				} ${product.title}">
                                <span class="swym-icon">${
					this.settings.swym_delete_list_icon
				}</span>
                             </button>
                </div>

                ${product.countdown_active
					? `<div class="tdb-soon-badge"><span class="tdb-soon-badge__dot"></span><span class="tdb-soon-badge__label">${this.dataset.comingSoonText || "Disponible le"}</span><span class="tdb-soon-badge__date">${product.countdown_date}</span></div>`
					: `<div class="quick-add no-js-hidden">
                <div class="medium-hide small-hide">
                        <button ${isButtonDisabled} data-purpose="cart" data-du="${productUrl}" data-epi="${
					selectedVariant.id
				}" data-empi="${
					product.id
				}" class="button button--primary quick-add__submit ${inCart} ${isSoldOut} swymcs-major-button swymcs-add-to-cart-btn swymcs-button" aria-label="${addToCartBtnText}" data-variant-cost="${selectedVariantPrice}">
                            ${addToCartBtnText}
                        </button>
                        </div>
                        <modal-opener class="large-up-hide">
                        <button ${isButtonDisabled} data-purpose="cart" data-du="${productUrl}" data-epi="${
					selectedVariant.id
				}" data-empi="${
					product.id
				}" class="button button--secondary quick-add__submit ${inCart} ${isSoldOut} swymcs-major-button swymcs-add-to-cart-btn swymcs-button" aria-label="${addToCartBtnText}" data-variant-cost="${selectedVariantPrice}">
                            ${addToCartBtnText}
                        </button>
                        </modal-opener>
                </div>`}
            </div>
        </div>
        </div>
    </div>
</div>
</li>`;
			});
			if (type == "wl") {
				this.productsContainer.innerHTML = productMarkup;
				this.productsContainer.classList.remove("swymcs-empty-list");
			} else if (type == "sfl") {
				this.sflProductsContainer.innerHTML = productMarkup;
			}
			this._scrollToTop();
			// this._updatePageFooter();
			this.dispatchEvent(new CustomEvent("swym:product-grid-loaded"));
		}

		_updatePageFooter() {
			const wishlistedItems = this.querySelectorAll(
				".swymcs-product-card .swymcs-add-to-cart-btn:not(:disabled)"
			);
			let prices = [];
			wishlistedItems.forEach((container) => {
				prices.push(+container.dataset.variantCost);
			});
			if (wishlistedItems.length) {
				const totalPrice = parseFloat(
					prices.reduce((sum, price, index) => sum + price, 0)
				).toFixed(2);
				this.subTotalField.innerHTML = `${currencyCode}${totalPrice}`;
				this._showContainer(this.wishlistFooter);
			} else this._hideContainer(this.wishlistFooter);
		}

		_renderEmptyList() {
			this.productsContainer.classList.add("swymcs-empty-list");
			this.productsContainer.innerHTML = window.emptyListContent;
			this.productsContainer
				.querySelector("#swym-empty-wishlist-container")
				.classList.remove("swym-hide-container");
			this._hideContainer(this.wishlistFooter);
		}

		_renderEmptySFLList() {
			this.productsContainer.classList.add("swymcs-empty-list");
			this.productsContainer.innerHTML = window.emptySFLListContent;
			this.productsContainer
				.querySelector("#swym-empty-sfl-container")
				.classList.remove("swym-hide-container");
			this._hideContainer(this.wishlistFooter);
		}

		async _renderShareListPopup(evt) {
			const target = evt.target;
			this._closeAdditionalOptionsPopup();
			this._renderShareList(target.dataset.lid);
		}

		async _renderAdditionalOptionsPopup(evt, lid) {
			const page = document.querySelector("swym-wishlist-page");
			const target = evt.target;
			if (target.id == "swymcs-additional-options") return;
			page._hidePopupContainer(page.querySelector(".swym-active-popup"));
			const action = target.dataset.action;
			page._closeAdditionalOptionsPopup();
			if (action == "share") page._renderShareList(lid);
			else if (action == "rename") page._renderRenameList();
			else if (action == "duplicate") page._renderDuplicateList();
			else if (action == "delete") page._renderDeleteList();
		}

		_closeAdditionalOptionsPopup() {
			this._hideContainer(this.shareListPopup);
			this._hideContainer(this.renameListPopup);
			this._hideContainer(this.duplicateListPopup);
			this._hideContainer(this.deleteListPopup);
			this._hidePopupContainer(this.additionalOptionsPopupContainer);
		}

		async _renderShareList(lid) {
			if (!window.isCustomer) {
				this._showPopupContainer(this.shareListAccountPopup);
				return;
			}
			const list = await this._markListAsPublic(lid);
			const shareableLink = await this._prepareShareLink(list);
			this.shareLinkField.textContent = shareableLink;
			this._showContainer(this.shareListPopup);
			this._showPopupContainer(this.additionalOptionsPopupContainer);
		}

		_renderRenameList() {
			this.renameListName.textContent = this.activeListTilte.textContent;
			this.renameListTextField.value = this.activeListTilte.textContent;
			this.renameListTextField.placeholder = this.activeListTilte.textContent;
			this._showContainer(this.renameListPopup);
			this._showPopupContainer(this.additionalOptionsPopupContainer);
		}

		_renderDuplicateList() {
			this.duplicateListName.textContent = this.activeListTilte.textContent;
			this.duplicateListTextField.value =
				"Copy Of " + this.activeListTilte.textContent;
			this.duplicateListTextField.placeholder =
				this.activeListTilte.textContent;
			this._showContainer(this.duplicateListPopup);
			this._showPopupContainer(this.additionalOptionsPopupContainer);
		}

		_renderDeleteList() {
			this.deleteListName.textContent = this.activeListTilte.textContent;
			this._showContainer(this.deleteListPopup);
			this._showPopupContainer(this.additionalOptionsPopupContainer);
		}

		/* Show / Hide containers */

		_overlayEvent(evt) {
			if (evt.target.nodeName == "BODY") {
				this.querySelectorAll(".swym-active-popup").forEach((popup) =>
					this._hidePopupContainer(popup)
				);
			}
		}

		_scrollToTop() {
			const header = document.querySelector(".swymcs-page-header");
			if (header) {
				var targetOffsetTop =
					header.getBoundingClientRect().top + window.scrollY;
				window.scrollTo({
					top: targetOffsetTop,
					behavior: "smooth",
				});
			}
		}

		_showPopupContainer(selector) {
			selector.classList.remove("swym-hide-container");
			selector.classList.add("swym-active-popup");
			this.body.classList.add("no-scroll");
		}

		_hidePopupContainer(selector) {
			selector.classList.add("swym-hide-container");
			selector.classList.remove("swym-active-popup");
			this.body.classList.remove("no-scroll");
		}

		_showContainer(selector) {
			selector.classList.remove("swym-hide-container");
		}

		_hideContainer(selector) {
			selector.classList.add("swym-hide-container");
		}

		/* Javascript APIs related functions */
		_getLists() {
			return new Promise(async (resolve, reject) => {
				this.swat.fetchLists({
					callbackFn: (lists) => resolve(lists),
					errorFn: (err) => reject(err),
				});
			});
		}

		_getListDetails(lid) {
			return new Promise(async (resolve, reject) => {
				this.swat.fetchListDetails(
					{ lid: lid },
					(list) => resolve(list),
					(error) => reject(error)
				);
			});
		}

		_getProductsFromList(lid) {
			return new Promise(async (resolve, reject) => {
				this.swat.fetchListCtx(
					{ lid: lid },
					(listContents) => resolve(listContents),
					(error) => reject(error)
				);
			});
		}

		async _getShopifyProductsData(products) {
			if (!products.length) return [];
			const section = this;
			let buggedProductsArray = [];
			let res = await Promise.all(
				products.map(async (pdp) => {
					try {
						const [storeUrlString, productHandleString] =
							pdp.du.split("/products/");
						const productHandle = productHandleString.split("?")[0];
						const reqURL = `${storeUrlString}${Shopify.routes.root}products/${productHandle}`;
						const jsonData = await section._fetchTranslatedProductData(reqURL);
						jsonData.productUrl = `${storeUrlString}${Shopify.routes.root}products/${jsonData.handle}?variant=${pdp.epi}`;
						pdp.productData = jsonData;
						return pdp;
					} catch (error) {
						const errorObj = {};
						errorObj[pdp.du] = error;
						buggedProductsArray.push(errorObj);
						return null;
					}
				})
			);

			console.log("Products with bugs - ", buggedProductsArray);
			res = res.filter((product) => product && product.productData);
			// console.log(res, "respnse");
			return res;
		}

		async _fetchTranslatedProductData(url) {
			const sectionHtml = await (
				await fetch(`${url}?section_id=swym-translated-product-data`)
			).text();
			const doc = new DOMParser().parseFromString(sectionHtml, "text/html");
			const productData = JSON.parse(
				doc.getElementById("swym-translated-product-data").textContent
			);
			const countdownActiveEl = doc.getElementById("swym-countdown-active");
			const countdownDateEl = doc.getElementById("swym-countdown-date");
			productData.countdown_active = countdownActiveEl
				? JSON.parse(countdownActiveEl.textContent)
				: false;
			productData.countdown_date = countdownDateEl
				? JSON.parse(countdownDateEl.textContent)
				: "";
			return productData;
		}

		_deleteProductFromList(product, lid, parentNode, type) {
			const onSuccess = async (deletedProduct) => {
				parentNode.remove();
				if (type == "sfl") {
					window.sflProductsCount -= 1;
					if (
						!this.sflProductsContainer.querySelector(".swymcs-product-card")
					) {
						this._renderEmptySFLState();
					}
				} else if (type == "wl") {
					window.wishlistProductCount -= 1;
					if (!this.productsContainer.querySelector(".swymcs-product-card")) {
						this._renderEmptyList();
					}
				}
				this.activeListItemCount.textContent = `(${window.wishlistProductCount})`;
			};
			const onError = (error) =>
				console.log("Error while deleting the Product", error);

			type == "sfl"
				? this.swat.SaveForLater.remove(lid, [product], onSuccess, onError)
				: this.swat.deleteFromList(lid, product, onSuccess, onError);
		}

		_renameList() {
			const listName = this.renameListTextField.value;
			const isValidListName = this._validateListName(
				listName.trim().toLowerCase(),
				this.renameListError
			);
			if (!isValidListName) return;
			const listUpdateConfig = {
				lid: window.currentActiveListId,
				lname: listName,
				lnote: "",
			};
			const onSuccess = async (updatedListObj) => {
				this._closeAdditionalOptionsPopup();
				this.lists = await this._getLists();
				this._renderListHeader(window.currentActiveListId);
			};
			const onError = (error) =>
				console.log(
					`Error while Renaming the List, ${window.currentActiveListId}`,
					error
				);
			_swat.updateList(listUpdateConfig, onSuccess, onError);
		}

		_duplicateList() {
			const listName = this.duplicateListTextField.value;
			const isValidListName = this._validateListName(
				listName.trim().toLowerCase(),
				this.duplicateListError
			);
			if (!isValidListName) return;
			const listConfig = {
				lname: listName,
				fromlid: window.currentActiveListId,
			};
			const onSuccess = async (listObj) => {
				this.lists = await this._getLists();
				this._renderListProducts(listObj.lid);
				this._closeAdditionalOptionsPopup();
			};
			const onError = (error) =>
				console.log(`Error while duplicating the List, ${lid}`, error);
			_swat.createList(listConfig, onSuccess, onError);
		}

		_deleteList() {
			const onSuccess = (deletedListObj) => {
				this._closeAdditionalOptionsPopup();
				this._renderWishlist(_swat);
			};
			const onError = (error) =>
				console.log(`Error while deleting the List, ${lid}`, error);
			_swat.deleteList(window.currentActiveListId, onSuccess, onError);
		}

		_validateListName(name, errorField) {
			const isValidList = false;
			if (name.length < 3) {
				errorField.textContent = this.swat.retailerSettings.Strings.ValidationErrorWishlistNameMinLength;
				return isValidList;
			}
			const lists = this.lists;
			const matchedList = lists.find(
				(list) => list.lname.trim().toLowerCase() == name
			);
			if (matchedList) {
				errorField.textContent = this.swat.retailerSettings.Strings.ValidationErrorWishlistNameDuplicate;
				return isValidList;
			}
			errorField.textContent = "";
			return !isValidList;
		}

		_validateEmail() {
			const emailPattern = /^\w+([.-]\w+)*@\w+([.-]\w+)*(\.\w{2,4})+$/;
			const isBlank = this.shareEmailField.value == "" ? true : false;
			const isInvalidString = !this.shareEmailField.value.match(emailPattern)
				? true
				: false;
			if (isBlank || isInvalidString) {
				this.shareListError.textContent = isBlank
					? "Please enter the email address"
					: "Please enter a valid email address";
				return false;
			}
			this.shareListError.textContent = "";
			return true;
		}

		_addProductToCart(button) {
			const epi = +button.dataset.epi;
			const empi = +button.dataset.empi;
			const du = button.dataset.du;
			this.swat.replayAddToCart(
				{
					empi,
					du,
					qty: 1,
				},
				epi,
				(c) => {
					button.classList.add("swymcs-product-in-cart");
					button.textContent = this.addToCartAddedText;
					window._cartRefresh();
				},
				(error) => {
					button.textContent = this.addToCartCanAddText;
					_swat.ui.uiRef.showErrorNotification({ message: error.description });
				}
			);
		}

		async _addAllProductToCart(evt) {
			const page = this;
			try {
				const productsData = [
					...page.querySelectorAll(
						".swymcs-product-card .swymcs-add-to-cart-btn:not(:disabled)"
					),
				].map((container) => ({
					id: +container.dataset.epi,
					quantity: 1,
				}));
				let formData = { items: productsData };

				const response = await fetch(
					window.Shopify.routes.root + "cart/add.js",
					{
						method: "POST",
						headers: { "Content-Type": "application/json" },
						body: JSON.stringify(formData),
					}
				);

				const cartResponse = await response.json();
				cartResponse.items.forEach((item) => {
					const variantId = item.id;
					const button = page.querySelector(
						`.swymcs-add-to-cart-btn[data-epi="${variantId}"]`
					);
					button.textContent = "Added to cart";
				});
				evt.target.textContent = "Added to cart";
				this._scrollToTop();
				document.dispatchEvent(new CustomEvent("ajaxProduct:added"));
			} catch (error) {
				_swat.ui.uiRef.showErrorNotification({ message: error.description });
				console.error("Error:", error);
			}
		}

		_markListAsPublic(lid) {
			return new Promise(async (resolve, reject) => {
				this.swat.markListPublic(
					lid,
					(list) => resolve(list),
					(err) => reject(err)
				);
			});
		}

		_prepareShareLink(list) {
			return new Promise(async (resolve, reject) => {
				this.swat.generateSharedListURL(
					list.lid,
					(link, lid) => resolve(link, lid),
					(err) => reject(err)
				);
			});
		}

		_shareListByCopy() {
			navigator.clipboard
				.writeText(this.shareLinkField.textContent)
				.then(() => {
					_swat.ui.uiRef.showSuccessNotification({
						message: this.ShareWishlistCopylinkSuccess,
					});
					this._closeAdditionalOptionsPopup();
				})
				.catch((error) =>
					_swat.ui.uiRef.showErrorNotification({ message: error.description })
				);
		}

		_shareListByEmail(evt) {
			const lid = evt.currentTarget.dataset.lid;
			const email = this._validateEmail();
			if (!email) return;
			const onSuccess = (response) => {
				_swat.ui.uiRef.showSuccessNotification({
					message: this.ShareWishlistEmailSuccess,
				});
				this._closeAdditionalOptionsPopup();
			};
			const onError = (error) =>
				_swat.ui.uiRef.showErrorNotification({ message: error.description });
			_swat.sendListViaEmail(
				{
					toEmailId: this.shareEmailField.value.trim(),
					note: this.shareMessageField.value,
					fromName: this.shareNameField.value,
					lid: lid,
				},
				onSuccess,
				onError
			);
		}

		_shareListOnPlatform(platform) {
			const shareUrl = this.shareLinkField.textContent;
			const note = this.shareMessageField.value;
			const fromName = this.shareNameField.value;
			const onError = (error) =>
				_swat.ui.uiRef.showErrorNotification({ message: error.description });
			let platformShareUrlTemplate = "";
			if (platform == "facebook")
				platformShareUrlTemplate = `https://www.facebook.com/sharer.php?u=${shareUrl}&t=${note}`;
			else if (platform == "twitter")
				platformShareUrlTemplate = `https://twitter.com/share?text=${note}&url=${shareUrl}`;
			_swat.shareListSocial(
				window.currentActiveListId,
				fromName,
				platformShareUrlTemplate,
				platform,
				note,
				onError
			);
		}

		/* Header functions */

		_loginButtonAction(evt) {
			const redirectionUrl = evt.currentTarget.getAttribute(
				"data-redirection-url"
			);
			const actionUrl = evt.currentTarget.getAttribute("data-action-url");
			localStorage.setItem("SWYM_REDIRECT_URL", redirectionUrl);
			localStorage.setItem("SWYM_ACTION_URL", actionUrl);
			location.href = actionUrl;
		}

		async _switchListsFromHeader(evt) {
			const page = document.querySelector("swym-wishlist-page");
			const lid = evt.target.dataset.lid;
			page._renderListHeader(window.currentActiveListId);
			page._renderListProducts(lid);
			page._hidePopupContainer(page.headerListsContainer);
		}

		/* Product Grid Events */

		async _eventsForProductsGrid(evt) {
			const target = evt.target;
			const page = document.querySelector("swym-wishlist-page");
			const purpose = target.dataset?.purpose;
			if (!purpose) return;
			evt.preventDefault();
			if (purpose == "cart") page._addProductToCart(target);
			else if (purpose == "delete") {
				page._deleteProductFromList(
					{
						epi: target.dataset.epi,
						empi: target.dataset.empi,
						du: target.dataset.du,
					},
					target.dataset.lid,
					target.closest(".swymcs-product-card"),
					target.dataset.type
				);
			}
		}

		/* Additional Options */
	}
	customElements.define("swym-wishlist-page", SwymWishlistPage);
}
